import IconButton from 'components/Luxkit/Button/IconButton'
import LineHistoryIcon from 'components/Luxkit/Icons/line/LineHistoryIcon'
import LineTimesIcon from 'components/Luxkit/Icons/line/LineTimesIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import { getRecentSearchDescription } from 'components/Search/utils'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { DEFAULT_FLEXIBLE_DURATION_RANGE } from 'constants/search'
import { formatOccupantsAsGuests } from 'lib/occupancyUtils'
import { pluralizeToString } from 'lib/pluralize'
import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'

const ButtonWrapper = styled.div`

  ${mediaQueryUp.sm} {
    display: none;
  }
`

const StyledListItem = styled(ListItem)`
  ${mediaQueryUp.sm} {
    position: relative;

    &:hover ${ButtonWrapper} {
      display: block;
    }
  }
`

interface Props {
  recentSearch: App.FullRecentSearch;
  onClick: (recentSearch: App.FullRecentSearch) => void;
  onDelete: (recentSearch: App.FullRecentSearch) => void;
}

function ReactSearchSuggestionItem(props: Props) {
  const { recentSearch, onClick, onDelete } = props

  const { dates, rooms } = recentSearch

  const dateText = getRecentSearchDescription(dates.checkIn, dates.checkOut, dates.flexibleMonths, dates.flexibleDuration as DEFAULT_FLEXIBLE_DURATION_RANGE, dates.isAnytime)

  const occupancyText = formatOccupantsAsGuests(...rooms)

  const subtitleText = dateText !== '' && occupancyText !== '' && occupancyText !== '' ? `${dateText} • ${occupancyText} • ${pluralizeToString('room', rooms.length)}` : ''
  const deleteIconRef = useRef<HTMLButtonElement>(null)
  const handleClick = useCallback((e: React.MouseEvent) => {
    if (deleteIconRef.current?.contains(e.target as any)) {
      onDelete(recentSearch)
    } else {
      onClick(recentSearch)
    }
  }, [onClick, onDelete, recentSearch])

  return (
    <StyledListItem
      size="medium"
      startIcon={<LineHistoryIcon />}
      onClick={handleClick}
      title={recentSearch.searchItem.format.mainText}
      subtitle={subtitleText}
    >
      <ButtonWrapper>
        <IconButton
          kind="tertiary"
          nonInteractable
          ref={deleteIconRef}
        >
          < LineTimesIcon/>
        </IconButton>
      </ButtonWrapper>
    </StyledListItem>
  )
}

export default ReactSearchSuggestionItem
